import attachEvents from "./attachEvents";
import createElementChangeListener from "../../elementChangeListener";
import curry from "../../lib/core/functional/curry";
import filterByRequirement from "./requirements";
import fromEvent from "../../utils/fromEvent";
import insertNodeBefore from "../../utils/insertNodeBefore";
import makePostContext from "./context";
import menuClickHandlerMap from "./menuClickHandlers";
import menuItems from "./menuItems";
import pipe from "../../lib/core/functional/pipe";
import process from "./itemsBuild";
import wrap from "./wrapContainer";

const makePreferencesTab = pipe(
    menuItems,
    filterByRequirement,
    process,
    attachEvents(fromEvent("click"), menuClickHandlerMap),
    wrap
);

const renderPreferenceTab = curry((context, wrapper) =>
    makePostContext(context, wrapper)
        .then(makePreferencesTab)
        .then((el) => {
            if (wrapper.matches("[data-user-prefs]")) {
                return wrapper.appendChild(el);
            } else {
                return insertNodeBefore(wrapper, el);
            }
        })
);

const postControls = (context) =>
    createElementChangeListener("article[elid],[data-user-prefs]", renderPreferenceTab(context));

export default postControls;

export const __PRIVATE__ = {
    filterByRequirement,
    menuItems,
    process,
    attachEvents,
    wrap,
    makePostContext,
};
